import { AnalyticsBrowser } from '@segment/analytics-next'
import CONSTANTS from '../../constants'

const Analytics = () => {
  const analytics = AnalyticsBrowser.load({
    writeKey: CONSTANTS.SEGMENT_WRITE_KEY
  })

  const identify = (fields: { id: string; name?: string; admin?: boolean }) => {
    const { id, ...rest } = fields
    analytics.identify(`${id}`, rest)
  }

  const track = (event: string, params: object) => {
    const properties = sanitize(params)
    analytics.track(event, properties)
  }

  const page = (params: object) => {
    const properties = sanitize(params)
    analytics.page(properties)
  }

  const sanitize = (params: object) => {
    return Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== ''
      )
    )
  }

  return {
    identify,
    track,
    page
  }
}

export default Analytics
